import React from 'react';
import QRCode from 'qrcode.react';
import { StyleSheet, Text } from '../base_components';
import TextButton from '../buttons/text_button';
import ImageButton from '../buttons/image_button';

import DialogOverlay from '../overlays/dialog_overlay';

const styles = StyleSheet.create({
  qrOverlay: {
    width: '29rem',
    paddingTop: '1.2rem',
    paddingBottom: '1.5rem',
    borderColor: '#ccc',
    borderWidth: 1,
    borderRadius: '1rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginLeft: '1.5rem',
    marginBottom: '2rem',
    alignSelf: 'center',
    color: '#333',
    fontSize: '2rem',
    fontWeight: '500',
  },
  subtitle: {
    marginLeft: '1.5rem',
    marginRight: '1.5rem',
    marginBottom: '2rem',
    color: '#555',
    fontSize: '1.3rem',
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: '0.5rem',
    right: '0.5rem',
    width: '1.2rem',
    height: '1.2rem',
    padding: '0.9rem',
    borderRadius: '0.5rem',
  },
  button: {
    marginTop: '4em',
    marginLeft: '1.5rem',
    marginRight: '1.5rem',
    alignSelf: 'stretch',
  },
});

const CLOSE_IMG = require('../../assets/img/close_black.png');

type Props = {
  style?: any;
  text: string;
  url: string;
  onDone: () => void;
};
type State = {};
export default class QrOverlay extends React.PureComponent<Props, State> {
  render() {
    const { style, text, url, onDone } = this.props;
    return (
      <DialogOverlay style={[styles.qrOverlay, style]} onOutsidePress={onDone}>
        <Text style={styles.title}>Wallet Connect</Text>
        <Text style={styles.subtitle}>{text}</Text>
        <QRCode value={url} />
        <TextButton
          style={styles.button}
          type='ghost-inverted'
          text='Cancel'
          onPress={onDone}
        />
        <ImageButton
          style={styles.closeButton}
          underlayColor='rgba(0,0,0,0.3)'
          source={CLOSE_IMG}
          onPress={onDone}
        />
      </DialogOverlay>
    );
  }
}
